<app-app-shell>
  <section class="dashbaord-shell h-100">
    <div class="container-fluid nav-wraper">
      <div class="row justify-content-center">
        <div class="col-12 pt-3 ps-md-5">
          <h1>
            {{bussinessName}}
          </h1>
          <nav class="dashbaord-nav d-flex overflow-auto">
            <a class="bg-app-secondary px-2 py-1 mr-1" routerLinkActive="active" routerLink="/profile">
              Profile
            </a>
            <a class="bg-app-secondary px-2 py-1 mx-1" routerLinkActive="active" routerLink="/notifications">
              Notifications
            </a>
            <a class="bg-app-secondary px-2 py-1 mx-1" routerLinkActive="active" routerLink="/customerorder">
              Customer Orders
            </a>
            <!-- <a class="bg-app-secondary px-2 py-1 mx-1" routerLinkActive="active" routerLink="/placeorder">
              Place Order
            </a> -->
            <a class="bg-app-secondary px-2 py-1 mx-1" routerLinkActive="active" routerLink="/store-orders">
              Store Orders
            </a><!--
            <a class="bg-app-secondary px-2 py-1 mx-1" routerLinkActive="active" routerLink="/gsn">
              GSN
            </a>-->
            <!-- <a class="bg-app-secondary px-2 py-1 mx-1" routerLinkActive="active" routerLink="/payment">
              Payment
            </a> -->
            <a class="bg-app-secondary px-2 py-1 mx-1" routerLinkActive="active" routerLink="/updates">
              Updates
            </a>
            <a class="bg-app-secondary px-2 py-1 mx-1" routerLinkActive="active" routerLink="/catalogue">
              Catalogues
            </a>
            <a class="bg-app-secondary px-2 py-1 mx-1" routerLinkActive="active" routerLink="/event-orders">
              Event Orders
            </a>
            <!--
            <a class="bg-app-secondary px-2 py-1 mx-1" routerLinkActive="active" routerLink="/invoice">
              Invoice
            </a>-->
          </nav>
        </div>
      </div>
    </div>
    <router-outlet></router-outlet>
  </section>
</app-app-shell>
